import React from "react";
import { Table, Tag, Typography } from "antd";
import { ArrowRightOutlined } from "@ant-design/icons";
import { UpdateRow, formatValue, pretty } from  "utils/auditLogUtils";
import { useTranslation } from "react-i18next";
import NoDataComponent from "components/Common/NoData";

const { Text } = Typography;

export const UpdateChangesTable: React.FC<{ rows: UpdateRow[] }> = ({ rows }) => {
  const { t } = useTranslation();

  if (!rows?.length) return <NoDataComponent />;

  const columns = [
    {
      title: t("Field"),
      dataIndex: "field",
      key: "field",
      render: (f: string) => <Text code>{t("auditLog." + f)}</Text>,
      width: "45%",
      ellipsis: true,
    },
    {
      title: t("From"),
      dataIndex: "from",
      key: "from",
      render: (v: any) =>
        Array.isArray(v) ? (
          <span>{v.map((x, i) => <Tag key={i}>{formatValue(x)}</Tag>)}</span>
        ) : (
          <Tag>{formatValue(v)}</Tag>
        ),
    },
    {
      title: "",
      key: "arrow",
      render: () => <ArrowRightOutlined />,
      width: 40,
    },
    {
      title: t("To"),
      dataIndex: "to",
      key: "to",
      render: (v: any) =>
        Array.isArray(v) ? (
          <span>{v.map((x, i) => <Tag color="processing" key={i}>{formatValue(x)}</Tag>)}</span>
        ) : (
          <Tag color="processing">{formatValue(v)}</Tag>
        ),
    },
  ];

  return (
    <Table
      rowKey={(r) => r.field}
      dataSource={rows}
      columns={columns}
      pagination={false}
      size="small"
    />
  );
};
